import "./error.css";

const Error = () => {
    return (
        <>
            <div className="error">Oops! Page not found.</div>
        </>
    );
};

export default Error;
